import React from "react";
import { motion } from "framer-motion";
import portfolio from "@/data/portfolio";
import AnimatedCounter from "@/components/AnimatedCounter";
import Timeline from "@/components/Timeline";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-40 border-t hairline">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-black/40" />
              <span className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
                01 · About
              </span>
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-black leading-[1.05]">
              {portfolio.aboutHeadline}
            </h2>
          </div>

          <div className="lg:col-span-8 lg:pt-4">
            <p className="text-lg md:text-xl text-gray-700 font-light leading-relaxed">
              {portfolio.bio}
            </p>
            <div className="mt-6 space-y-5 text-base md:text-lg text-gray-600 font-light leading-relaxed">
              {portfolio.bioLong.split("\n\n").map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 md:mt-28 grid grid-cols-2 lg:grid-cols-4 border-t hairline">
          {portfolio.stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              data-testid={`stat-card-${i}`}
              className={`py-10 md:py-14 ${i > 0 ? "lg:border-l hairline" : ""} ${i === 2 ? "border-t lg:border-t-0 hairline" : ""} ${i === 3 ? "border-t lg:border-t-0 border-l hairline" : ""} ${i === 1 ? "border-l hairline" : ""} pl-6 md:pl-8`}
            >
              <div className="text-5xl md:text-6xl lg:text-7xl font-light tracking-tight text-black leading-none">
                {typeof s.value === "number" ? (
                  <AnimatedCounter value={s.value} suffix={s.suffix} />
                ) : (
                  <span className="font-serif-display text-4xl md:text-5xl lg:text-6xl">
                    {s.text}
                  </span>
                )}
              </div>
              <div className="mt-4 text-sm text-gray-500 max-w-[20ch]">{s.label}</div>
            </motion.div>
          ))}
        </div>

        {/* Timeline */}
        <div className="mt-24 md:mt-32">
          <div className="flex items-center gap-3 mb-10">
            <span className="inline-block w-8 h-px bg-black/40" />
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              Career timeline
            </span>
          </div>
          <Timeline items={portfolio.timeline} />
        </div>
      </div>
    </section>
  );
}
